import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/UserProfile`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	firstName: string;
	lastName: string;
	password: string | undefined;
	newPassword: string | undefined;
	languageId: string;
	profilePictureId: string | undefined;
	userSettings: UserSettingsApi | null;
}

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
	'User.Profile.Allergens'?: string;
};

export enum ValueScope {
	Total = 'Total',
	Person = 'Person',
	Parts = 'Parts',
	HundredGrams = 'HundredGrams',
}
